import { Data } from './Data';
import { Header } from './Header';

export const WeightCell = { Data, Header };
